import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'
import { type GQLError } from '@egw/clients'
import { authsvsGetAllPasskeys, getPasskeys } from '../../services'
import { type AuthsvsPasskeysOutput, type PasskeysOutput } from '../../models'

/**
 * Passkeys state hook
 * @param options - tanstack useQuery options
 * @returns tanstack useQuery result, data is of type PasskeysOutput
 */
export const usePasskeys = (
  options?: Omit<UseQueryOptions<PasskeysOutput, GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<PasskeysOutput, GQLError> =>
  useQuery<PasskeysOutput, GQLError>({
    queryKey: ['passkeys'],
    queryFn: getPasskeys,
    ...options,
  })

/**
 * Passkeys state hook
 * @param options - tanstack useQuery options
 * @returns tanstack useQuery result, data is of type PasskeysOutput
 */
export const useAuthsvsPasskeys = (
  options?: Omit<UseQueryOptions<AuthsvsPasskeysOutput[], GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<AuthsvsPasskeysOutput[], GQLError> =>
  useQuery<AuthsvsPasskeysOutput[], GQLError>({
    queryKey: ['passkeys'],
    queryFn: authsvsGetAllPasskeys,
    ...options,
  })
